<template>
    <div>
        <v-list>
             <v-list-item two-line>
                <v-list-item-avatar>
                        <v-img 
                            v-if="me.uploads && me.uploads.length > 0"
                            :src="me.uploads[0] | urlUpload"
                            :lazy-src="me.uploads[0] | urlUpload"
                        >
                            <template v-slot:placeholder>
                                <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                                >
                                <v-progress-circular
                                    indeterminate
                                    color="grey lighten-5"
                                ></v-progress-circular>
                                </v-row>
                            </template>
                        </v-img>
                        <v-icon size="100" v-else dark>
                            mdi-account-circle-outline
                        </v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title class="body-2">{{ me.name }}</v-list-item-title>
                    <v-list-item-subtitle class="caption">
                        <v-row dense>
                            <v-col cols="auto">
                                {{ me.profile }}
                            </v-col>
                            <v-col cols="auto">
                                <router-link :to="{ 
                                    name: 'admin.users.index', 
                                    params: {
                                        id: me.id                                
                                    } 
                                }">
                                    <v-icon size="15">
                                        mdi-pencil
                                    </v-icon>
                                </router-link>
                            </v-col>
                        </v-row>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>    
        </v-list>
        <v-divider></v-divider>
        <v-list
            nav
            dense
        >
            <v-list-item-group
                v-model="selectedItem"
                color="primary"
            >
            <span v-for="(item, i) in single_items"
                    :key="i">

                <router-link 
                    :to="{
                        name: item.link,
                        params: item.params 
                    }" 
                    class="nav-link"
                >                    
                    <template v-if="item.text == 'Imóveis'">

                        <template v-if="propertyVersion == 2 && item.new == true">
                            <div>
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon v-text="item.icon"></v-icon>
                                    </v-list-item-icon>

                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{ item.text }}

                                            <v-chip
                                                v-if="item.new"
                                                class="ma-2"
                                                x-small
                                                color="pink"
                                                label
                                                dark
                                            >
                                                NOVO
                                            </v-chip>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </div>
                        </template>

                        <template v-if="propertyVersion == 1">
                            <div>
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon v-text="item.icon"></v-icon>
                                    </v-list-item-icon>

                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{ item.text }}

                                            <v-chip
                                                v-if="item.new"
                                                class="ma-2"
                                                x-small
                                                color="pink"
                                                label
                                                dark
                                            >
                                                NOVO
                                            </v-chip>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </div>
                        </template>

                    </template>

                    

                    <template v-else>
                        <v-list-item >
                            <v-list-item-icon>
                                <v-icon v-text="item.icon"></v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ item.text }}

                                    <v-chip
                                        v-if="item.new"
                                        class="ma-2"
                                        x-small
                                        color="pink"
                                        label
                                        dark
                                    >
                                        NOVO
                                    </v-chip>
                                </v-list-item-title>
                            </v-list-item-content>
                            
                        </v-list-item>
                    </template>

                </router-link>
            </span>


                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>mdi-login-variant</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title @click="logout()">Sair</v-list-item-title>
                    </v-list-item-content>
                    
                </v-list-item>

            </v-list-item-group>
        </v-list>

    </div>
</template>

<script>
import { singleItems } from '@/constants/menuItems'

export default {
    created() {
        this.checkMenu()
    },

    props: {
        object: {
            require: false,
        },
    }, 

    data () {
        return {
            selectedItem: '',
            single_items: singleItems,
        }
    },

    computed: {
        me () {
          return this.$store.state.auth.me
        },

        tenant() {
            return this.$store.state.tenants.items.data    
        },

        propertyVersion() {
            return this.tenant?.[0]?.json_params?.property_version || '1';
        }
    },

    watch: {
        me () { 
            this.checkMenu()
            /*  
            if(this.me.id){
                this.checkMenu()
            }else{
                this.logout()
            } 
            */
        },
    },

    methods: {
        logout () {            
            this.$store.dispatch('logout')
        },

        checkMenu(){
            if(this.me.profile && this.me.profile != 'Master'){
                const menu = []

                this.single_items.forEach(i => {
                    if(i.id != 70 && i.id != 80 && i.id != 90 && i.id != 100){
                        menu.push(i)
                    }   
                })
                this.single_items = menu
            }

             
            if(this.me.json_params && this.me.json_params.fac_version && this.me.json_params.fac_version == 2){
                var result = this.single_items.filter( model => model.id == 25);
                
                if(result.length == 0){
                    const new_property = {id:25, new: true, text: 'Facs', icon: 'mdi-face-agent', link: 'admin.facs2.index'};
                    this.single_items.push(new_property);
                }
            }
            
            /*
            if(this.me.json_params && this.me.json_params.proposal == 'true'){
                const new_proposal = {id:60, new: true, text: 'Propostas', icon: 'mdi-file-sign', link: 'admin.proposals.index', params:{} }
                this.single_items.push(new_proposal);
            }
            */

            this.single_items.sort((a, b) => a.id - b.id);
        },
    },

}
</script>

<style >
.nav-link {
    text-decoration: none;
    color: black;
}

.bg-active {
  background-color: #E3F2FD;
}

</style>